import {
  PAYLOAD_MAP,
  DETAILS_ELEMENTS_CONFIG,
  EVENTS_ELEMENTS_CONFIG,
  CONDITIONS_ELEMENTS_CONFIG,
  ACTIONS_ELEMENTS_CONFIG,
} from "../constants.js";
import {
  getPartsFromCombinedValue,
  getConfigKeys,
  getNextKey,
  validateFieldData,
  mapObjectOptions,
  mapArrayOptions,
  getSubSubConfigCombinedValue,
  getSubSubConfigCurrentKey,
  getSubSubConfigsFromItem,
  getUUID,
} from "../utils.js";

export default {
  computed: {
    getAction() {
      return this.$route.params.trigger_action;
    },
    getType() {
      return this.$route.params.type;
    },
    getWorkflowId() {
      return this.$route.params?.workflowId;
    },
    getTriggerId() {
      return this.$route.params?.toolId;
    },
    selectConfig() {
      return { label: "name", trackBy: "id" };
    },
    isViewMode() {
      return this.$route.params.action === "view"
        || this.$route.params.trigger_action === "view"
        || this.$route.name == "check admin details"
        || this.$route.name == "Package Tools";
    },
    disabledSubmit() {
      const baseValidation = !(this.details?.model?.name?.trim().length)
        || Object.values(this.details?.errors || {}).some(e => e)
        || this.isInvalidEvent
        || this.isInvalidActions;

      return this.isConditionsPartiallyFilled
        ? baseValidation || this.isInvalidConditions
        : baseValidation;
    },
    isInvalidEvent() {
      return validateFieldData(this.events);
    },
    isInvalidActions() {
      return validateFieldData(this.actions);
    },
    isInvalidConditions() {
      return validateFieldData(this.conditions);
    },
    isConditionsPartiallyFilled() {
      return this.conditions.model[0].type.length > 0;
    },
    submitMessage() {
      return this.getTriggerId ? "Trigger is successfully updated" : "New Trigger is successfully created";
    },
    detailsElements() {
      return DETAILS_ELEMENTS_CONFIG;
    },
    eventsElements() {
      return EVENTS_ELEMENTS_CONFIG;
    },
    conditionsElements() {
      return CONDITIONS_ELEMENTS_CONFIG;
    },
    actionsElements() {
      return ACTIONS_ELEMENTS_CONFIG;
    }
  },

  methods: {
    getSubSubConfigCombinedValue,
    getSubSubConfigCurrentKey,
    getSubSubConfigsFromItem,
    getUUID,

    getPayloadForArrayOfObjects(field) {
      const keys = PAYLOAD_MAP.get(field);
    
      const result = keys
        .map(key => this.getItemPayload({ el: this[field].model, field, key }))
        .filter(item => item);
    
      return result;
    },

    getPayloadForArrayOfArrays(field) {
      const keys = PAYLOAD_MAP.get(field);
    
      const result = this[field].model
        .map((el, index) => {
          return keys
            .map(key => this.getItemPayload({ el, field, key, index }))
            .filter(item => item);
        });
    
      return result;
    },

    getItemPayload({ el, field, key, index }) {
      const combinedValue = el[key];
      const { id, configId, configValue } = getPartsFromCombinedValue(combinedValue);
      const { idKey, configIdKey, configValueKey } = getConfigKeys(field);

      if (Array.isArray(this[field].options)) {
        return this[field].options?.[index]?.[key]
          ?.find(el => el?.[idKey] === id && el?.[configIdKey] === configId && String(el?.[configValueKey]) === configValue);
      }
    
      return this[field].options[key]
        .find(el => el[idKey] === id && el[configIdKey] === configId && String(el[configValueKey]) === configValue);
    },

    getArrayItemFromOptions(combinedValue, field, currentKey, index) {
      const { idKey, configIdKey, configValue } = getConfigKeys(field);
      const { id, configId, configValueKey } = getPartsFromCombinedValue(combinedValue);
    
      return this[field].options[index][currentKey]
        ?.find(el => el[idKey] === id && el[configIdKey] === configId && el[configValueKey] === configValue) ?? {};
    },

    getObjectItemFromOptions(combinedValue, field, currentKey) {
      const { idKey, configIdKey, configValue } = getConfigKeys(field);
      const { id, configId, configValueKey } = getPartsFromCombinedValue(combinedValue);
    
      return this[field].options[currentKey]
        ?.find(el => el[idKey] === id && el[configIdKey] === configId && el[configValueKey] === configValue) ?? {};
    },

    checkShowSubConfig(combinedValue, field, currentKey, index) {
      if (this.isViewMode) {
          const nextKey = getNextKey(field, currentKey);
          if (nextKey) {
            const nextItem = !isNaN(index)
              ? this[field].options[index][nextKey] ?? {}
              : this[field].options[nextKey] ?? {};
    
            return Object.keys(nextItem).length > 0;
          }
      }
    
      return !isNaN(index)
        ? this.getArrayItemFromOptions(combinedValue, field, currentKey, index).has_child
        : this.getObjectItemFromOptions(combinedValue, field, currentKey).has_child;
    },

    getMappedObjectOptions(field, key) {
      return mapObjectOptions(this[field].options, field, key);
    },

    getMappedArrayOptions(field, key, index) {
      return mapArrayOptions(this[field].options, field, key, index);
    },
  }
}
